import { Stack, Typography } from '@healthinal/ui';
import { ReactNode } from 'react';
import { HistoryDto, PatientBasicsDto } from '../../../api/generated/model';
import { formatDateWithGermanMonth } from '../../../utils/date.ts';

interface Props {
  history: HistoryDto;
  subject?: string | ReactNode;
  action: string;
  patient: PatientBasicsDto;
  children: ReactNode;
}

export function HistoryEntry({ history, subject, action, patient, children }: Props) {
  return (
    <Stack gap={1} paddingBottom={2}>
      <Stack direction={'row'} gap={0.5} alignItems={'center'}>
        <Typography level={'title-lg'}>{formatDateWithGermanMonth(history.date)}</Typography>
        <Typography level={'body-lg'}>{subject}</Typography>
        <Typography level={'title-lg'}>
          {patient.firstName} {patient.lastName}
        </Typography>
        <Typography level={'body-lg'}>{action}</Typography>
        <Typography level={'body-lg'}>
          {history.employee?.firstName} {history.employee?.lastName}
        </Typography>
      </Stack>
      <Stack>{children}</Stack>
    </Stack>
  );
}
